import type {
  OfflineCheckoutDeliveryAddress,
  OfflineCheckoutResult,
  OfflineFulfillmentType,
  OfflineSaleBill,
  OfflineSaleSession,
} from '../types';

import { formatOfflineAddressLines } from './checkoutBody';

export interface SaleBillStore {
  storeCode: string;
  name: string;
  city: string;
}

export function buildOfflineSaleBill(input: {
  result: OfflineCheckoutResult;
  session: OfflineSaleSession;
  store: SaleBillStore | null;
  customerName: string;
  customerPhone: string;
  couponCode: string | null;
  soldAt: string;
  fulfillmentType: OfflineFulfillmentType;
  deliveryAddress?: OfflineCheckoutDeliveryAddress;
}): OfflineSaleBill {
  const { result, session, store } = input;
  const extraDeliveryPaise = Math.max(0, result.totalAmountPaise - session.totalAmountPaise);
  return {
    orderId: result.orderId,
    orderNumber: result.orderNumber,
    status: result.status,
    paymentStatus: result.paymentStatus,
    message: result.message,
    soldAt: input.soldAt,
    storeCode: store?.storeCode ?? '',
    storeName: store?.name ?? '',
    storeCity: store?.city ?? '',
    customerName: input.customerName || session.customerName,
    customerPhone: input.customerPhone || session.customerPhoneNumber,
    couponCode: input.couponCode ?? '',
    lines: session.cart.items.map((item) => ({
      productId: item.productId,
      name: item.productName,
      quantity: item.quantity,
      unit: item.unit,
      unitPricePaise: item.unitPricePaise,
      lineTotalPaise: item.unitPricePaise * item.quantity,
      mrpPaise: item.mrpPaise,
    })),
    subtotalPaise: session.cart.subtotalPaise,
    handlingChargePaise: session.cart.handlingChargePaise,
    deliveryChargePaise: session.cart.deliveryChargePaise + extraDeliveryPaise,
    discountPaise: session.cart.discountPaise,
    couponDiscountPaise: session.couponDiscountPaise,
    totalAmountPaise: result.totalAmountPaise,
    fulfillmentType: input.fulfillmentType,
    addressLines: formatOfflineAddressLines(input.deliveryAddress),
  };
}
